import styled, { css } from 'styled-components';

import { ButtonEl } from 'components/common/button/styles';
import { Flow } from 'components/common/flow';
import SiteLink from 'components/common/site-link';
import { largeDesktop, mobile } from 'utils/media';
import theme from 'utils/theme';

import { Step } from '../text';

export const Content = styled(Flow)`
  padding: var(--space-s-l);
  flex-basis: 60%;
  flex-grow: 1;
  z-index: ${theme.zIndexes.low};
`;

interface IWrapperProps {
  backgroundHex: string;
  textHex: string;
  fullBleedImage: boolean;
}

export const Wrapper = styled.div<IWrapperProps>`
  background: ${({ backgroundHex }) => backgroundHex};
  color: ${({ textHex }) => textHex};

  --radii: ${theme.radii.default};
  position: relative;
  border-radius: var(--radii);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  overflow: hidden;

  h2 {
    white-space: pre-line;
  }

  figure {
    position: relative;
    align-self: stretch;
    flex-basis: 40%;
    min-width: var(--advert-image-min-width, 180px);
    flex-grow: 1;

    &:before {
      content: '';
      display: block;
      min-height: 300px;

      @supports (aspect-ratio: 1) {
        min-height: auto;
        aspect-ratio: var(--advert-image-aspect, 1);
      }
    }
  }

  ${ButtonEl} {
    &,
    &:active {
      position: static;
      transform: none;
    }

    :after {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
    }
  }

  ${({ fullBleedImage }) =>
    fullBleedImage &&
    css`
      ${mobile} {
        min-height: 240px;
      }

      figure {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
      }

      ${Content} {
        margin-top: auto;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7));
        padding-top: var(--space-3xl);
      }
    `}
`;

export const Caption = styled.div`
  padding: var(--space-2xl) var(--space-s-l) var(--space-s);
  text-align: left;
  color: ${theme.colors.white};
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));

  svg {
    max-width: 100%;
    height: auto;
  }
`;

export const AdvertLink = styled(SiteLink)`
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
`;

export const Eyebrow = styled(Step)`
  font-family: ${theme.fonts.heading};
  margin: 0;

  ${largeDesktop} {
    svg {
      max-width: 60%;
      width: 15vw;
      height: auto;
    }
  }
`;

export const Body = styled.p`
  ${mobile} {
    display: none;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
